import { styled, Stack, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const TrackSectionContainerBase = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  gap: theme.spacing(2),
}));

export const TrackSectionContainer = (
  props: ComponentProps<typeof TrackSectionContainerBase>
) => <TrackSectionContainerBase direction="row" {...props} />;

export const StyledTextContainer = styled(Stack)({
  overflow: 'hidden',
});

export const StyledSongTitle = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: 12,
  fontWeight: 700,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[50],
}));

export const StyledSongSource = styled(Typography)(({ theme }) => ({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  fontSize: 12,
  fontWeight: 400,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.grey[400],
}));
